module.exports = {
  siteTitle: 'Fundación Son Luz', // <title>
  manifestName: 'Fundación Son Luz',
  manifestShortName: 'Fundación', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: `/`, // This path is subpath of your hosting https://domain/portfolio
  heading: 'Fundación Son Luz',
  subHeading: 'Niños del mañana',
  // social
  socialLinks: [
    {
      style: 'solid',
      icon: 'fa-envelope',
      name: 'Email',
      url: 'mailto:FundacionSonLuz@gmail.com',
    },
  ],
};
